export default "__VITE_ASSET__DIwgmlju__"